import axios from 'axios';
import type { ApiError } from '@/types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

/**
 * Unauthenticated API client for endpoints that don't require authentication
 * (e.g., login, register, forgot password)
 */
export const unauthenticatedApiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Response interceptor for error handling
unauthenticatedApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Extract error from API response format: { success: false, error: { message, code } }
    const apiError: ApiError = {
      message:
        error.response?.data?.error?.message ||
        error.message ||
        'An unexpected error occurred',
      code: error.response?.data?.error?.code,
      status: error.response?.status,
    };

    return Promise.reject(apiError);
  }
);

export default unauthenticatedApiClient;

